import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component to prevent automatic scroll-to-top on route changes
 * Only scrolls to top when pathname actually changes (not on hash changes or data updates)
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);
  const isInitialMount = useRef(true);

  useEffect(() => {
    // On initial mount, don't scroll (let browser handle it)
    if (isInitialMount.current) {
      isInitialMount.current = false;
      prevPathnameRef.current = pathname;
      return;
    }

    // Only scroll to top if pathname actually changed (new route)
    // Don't scroll on hash changes, query param changes, or data updates
    if (prevPathnameRef.current !== pathname) {
      // Scroll to top only on actual route change
      window.scrollTo({ top: 0, behavior: 'smooth' });
      prevPathnameRef.current = pathname;
    }
    // If pathname hasn't changed, don't scroll (data updates shouldn't cause scroll)
  }, [pathname]);

  return null;
}

export default ScrollToTop;

